import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { PencilSquareIcon } from "@heroicons/react/24/solid";
import Modal from "../../../../components/Modal";
import React, { Fragment, useState } from "react";
import UserPermissionTable from "./UserPermissionTable";
import { useGetUsers } from "./hooks/useGetUsers";
import { useRecoilValue, useRecoilState } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import useDeleteUsers from "./hooks/useDeleteUser";
import { selectedRowsStateEmployeeType } from "../../EmployeeConfiguration/EmployeeType/atoms/atoms";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useUpdateFranchiseUserStatus } from "../../../../actions/Utilities/RolePermission/useUpdateFranchiseUserStatus";
import EditButton from "../../../../components/EditButton";
import { useHistory } from "react-router-dom";
import { Permission } from "../Permission";
import { editPermissionsState } from "./atoms/atom";
import CancelButton from "../../../../components/CancelButton";
import SelectInput from "../../../../components/SelectInput";
import SaveButton from "../../../../components/SaveButton";
import { useGetRolesWithUsers } from "../RolesManagement/hooks/useGetRolesWithUsers";
import { useUpdateUserRole } from "./hooks/useUpdateUserRole";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import MaterialUtilitiesTable from "../../../../components/tables/MaterialUtilitiesTable";

const UserManagementTable = () => {
  const userAccount = useRecoilValue(accountAtom);
  const BulkDeleteUsers = useDeleteUsers();
  const UpdateUserRole = useUpdateUserRole();
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateEmployeeType
  );
  const editPermission =
    PERMISSIONS.permission_utilities_userrolemanagement_management_edit;
  const editUserManagement =
    PERMISSIONS.permission_utilities_userrolemanagement_edit;
  const permissions = useRecoilValue(permissionsSelector);
  const hasEditPermission = permissions.includes(editPermission);
  const hasEditUserManagement = permissions.includes(editUserManagement);
  const [editPermissions, setEditPermissions] = useState(false);
  const [editUserRole, setEditUserRole] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const { FranchiseUserMutation } = useUpdateFranchiseUserStatus();
  const [isEditModal, setIsEditModal] = useState(false);
  const [userId, setUserId] = useState();
  const [changedRole, setChangedRole] = useState({});
  const { data: RolesData, isLoading: roleLoading } = useGetRolesWithUsers();
  const roleOptions = RolesData?.map((x) => {
    return {
      label: x.roleName,
      value: x.roleId,
    };
  });

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setIsBulkSelected((prev) => !prev);
  };
  const handleBulkDelete = () => {
    const ids = selectedRows.map(
      (row) => row.carrierAgreementManagemenSystemAccountId
    );
    BulkDeleteUsers(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    // setDisabledButton(false);
  };
  //const [isOpen, setOpenModal] = useState(false);
  const [user, setUser] = useState(-1);

  const { data: UserData, isLoading: userLoading } = useGetUsers();

  const handleCheckbox = (userId, userType, status) => {
    if (userType === "isFranchise") {
      const userUpdate = {
        userId,
        userType,
        status: !status,
      };
      FranchiseUserMutation.mutate(userUpdate);
    } else if (userType === "isConfie") {
      const userUpdate = {
        userId,
        userType,
        status: !status,
      };
      FranchiseUserMutation.mutate(userUpdate);
    } else if (userType === "isMexico") {
      const userUpdate = {
        userId,
        userType,
        status: !status,
      };
      FranchiseUserMutation.mutate(userUpdate);
    }
  };

  const distributeData = (rowDetails) => {
    setUser(rowDetails.carrierAgreementManagemenSystemAccountId);
    // getUserPermissionData.mutate(rowDetails.carrierAgreementManagemenSystemAccountId);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRows?.length
    } ${selectedRows?.length > 1 ? "Users" : "User"} ?`}</div>
  );
  const handleSave = () => {
    UpdateUserRole(changedRole);
    setEditUserRole(false);
    setIsEditModal(false);
  };
  const columns = [
    {
      title: "Name",
      field: "fullName",
      render: (row) => {
        return row.fullName;
      },
      sortable: true,
    },
    {
      title: "E-mail",
      field: "emailAddress",
      sortable: true,
    },
    {
      title: "UPN",
      field: "upn",
      sortable: true,
    },
    {
      title: "Role",
      field: "roleName",
      sortable: true,
      render: (row) => {
        return editUserRole && userId === row.accountId ? (
          <div className="text-center">
            <SelectInput
              options={roleOptions}
              defaultValue={roleOptions?.filter((x) => x.value === row.roleId)}
              isClearable={true}
              onChange={(data) => {
                const newData = {
                  userId: row.accountId,
                  roleId: data ? data.value : 0,
                  updatedBy: userAccount.userName,
                };
                setChangedRole(newData);
              }}
            />
          </div>
        ) : (
          <div>
            {row.roleName ? (
              row.roleName
            ) : (
              <span className="undefineTextColor">Unspecified</span>
            )}
          </div>
        );
      },
    },
    {
      title: "Franchise",
      align: "center",
      render: (row) => {
        return (
          <div className="text-center mr-5">
            <input
              type="checkbox"
              checked={row.isFranchise}
              onChange={() =>
                handleCheckbox(row.accountId, "isFranchise", row.isFranchise)
              }
              disabled={hasEditUserManagement ? !hasEditUserManagement : true}
            />
          </div>
        );
      },
      sortable: true,
    },
    {
      title: "Confie",
      center: true,
      align: "center",
      render: (row) => {
        return (
          <div className="items-center mr-5">
            <input
              type="checkbox"
              checked={row.isConfie}
              onChange={() =>
                handleCheckbox(row.accountId, "isConfie", row.isConfie)
              }
              disabled={hasEditUserManagement ? !hasEditUserManagement : true}
            />
          </div>
        );
      },
      sortable: true,
    },
    {
      title: "Mexico",
      center: true,
      align: "center",
      render: (row) => {
        return (
          <div className="items-center mr-5">
            <input
              type="checkbox"
              checked={row.isMexico}
              onChange={() =>
                handleCheckbox(row.accountId, "isMexico", row.isMexico)
              }
              disabled={hasEditUserManagement ? !hasEditUserManagement : true}
            />
          </div>
        );
      },
      sortable: true,
    },
    {
      title: "Action/s",
      export: false,
      align: "center",
      render: (row) => {
        return (
          <div className="flex place-content-center items-center mr-5 sm:h-full sm:flex-col xl:flex-row gap-2 ">
            {editUserRole && userId === row.accountId ? (
              <>
                <SaveButton
                  onClick={() => {
                    setIsEditModal(true);
                  }}
                />
                <CancelButton
                  onClick={() => {
                    setEditUserRole(false);
                  }}
                />
              </>
            ) : (
              <>
                <EditButton
                  onClick={() => {
                    setUserId(row.accountId);
                    setEditUserRole(true);
                  }}
                  className={
                    editUserRole // || selectedRows.length > 0
                      ? "opacity-50 rounded-full items-center bg-quaternary hover:bg-tertiary text-white hover:bg-hquaternary "
                      : "opacity-100 rounded-full items-center bg-quaternary hover:bg-tertiary text-white hover:bg-hquaternary"
                  }
                  disabled={editUserRole}
                  buttonText="Edit User"
                />
              </>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="m-4 rounded-md box-shadow border-t overflow-x-auto">
      {!editPermissions && (
        <>
          {/* <div className="text-secondary italic text-xs3 ">
            <p className="font-bold italic inline-block mr-1 mb-1">Note: </p>
            Tick the box to deactivate some data.
          </div> */}

          <MaterialUtilitiesTable
            toolbar={true}
            showTitle={false}
            search={true}
            columns={columns}
            data={UserData ? UserData : []}
            isLoading={userLoading}
            isDeactivate={true}
            selectableRowDisabled={(row) => !row.isActive}
            showTextRowsSelected={false}
            exportButton={false}
          />
        </>
      )}
      {editPermissions && (
        <Permission
          id={userId}
          permissionType="user"
          setEditPermissions={setEditPermissions}
        />
      )}

      <Modal
        isOpen={user > -1}
        //onClose={() => setOpenModal(false)}
        onClose={() => setUser(-1)}
        hasCloseButton={false}
        closeOutside={false}
      >
        <div className="space-y-5">
          <Fragment>
            <UserPermissionTable id={user} setUser={setUser} />
          </Fragment>
        </div>
      </Modal>

      <ConfirmBoxDelete
        ModalTitle="Deactivate Employee Account?"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={isBulkSelected ? handleBulkDelete : handleBulkDelete}
      />

      <ConfirmBoxModal
        ModalTitle={"Update User Role"}
        qConfirmation={`Are you sure you want to update this?`}
        isOpen={isEditModal}
        onClose={() => setIsEditModal(false)}
        onClickFunction={() => {
          handleSave();
        }}
      />
    </div>
  );
};

export default UserManagementTable;
